import $ from 'jquery';

// Add to window to make global
window.toggle_duration = function (container){
	var which = $(container).find('.event-duration-which').val();

	if(which == 'choice'){
		$(container).find('.event-duration-choice').hide();
		$(container).find('.event-duration-other').show();
		$(container).find('.event-duration-link').html('Dropdown');
		$(container).find('.event-duration-which').val('other');
	}else{
		$(container).find('.event-duration-choice').show();
		$(container).find('.event-duration-other').hide();
		$(container).find('.event-duration-link').html('Custom');
		$(container).find('.event-duration-which').val('choice');
	}
}

// Add to window to make global
window.toggle_speaker = function (container){
	$(container).find('.lecture-speakers-employee').toggle();
	$(container).find('.lecture-speakers-custom').toggle();

	// Need to recreate chosen on each load.
	$(container).find('.lecture-speakers-employee-select').val('').chosen("destroy").chosen();

	$(container).find('.lecture-speakers-name').val('');
	$(container).find('.lecture-speakers-institution').val('');
}



// WEBPACK FOOTER //
// ./EventBundle/Resources/assets/js/event.js